import React, { useState, useEffect, useRef } from 'react';
import FormSection from './components/newformsection';
import Navbar from './components/navbar';
import { useParams } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import { useReactToPrint } from 'react-to-print';
import { Dialog, Classes, Button } from '@blueprintjs/core'; // Import for popup
import { useSelector } from 'react-redux'; // Import useSelector for package comparison
import { FaCrown } from 'react-icons/fa'; // Import the crown icon from react-icons
import { useDispatch } from 'react-redux';
import {FaExclamationTriangle  } from 'react-icons/fa';
import { loginModal } from '../Redux/authAction';
import api from '../config/api'; // Import API configuration

export default function CoverPageBuilder() {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    name: 'Justin Edwards',
    jobTitle: 'Graphic Designer',
    phone: '(111) 222-3333',
    email: 'justin.edwards@gmail.com',
    address: 'Charlotte Area, North Carolina',
    recipient: {
      name: 'Mr. Smith',
      position: 'Hiring Manager',
      company: 'Carlton Design Firm',
      address: '12 Pleasant St, Charlotte, North Carolina',
    },
    date: '29 November 2021',
    subject: 'Application for the Design Intern Position',
    introduction: `By means of this letter I would like to inquire about the possibility of filling an outstanding internship position at Carlton Design Firm. My preference would be to fill the position of Design Intern.`,
    motivation: `I am currently an honor student at Central High School, focusing my studies and extracurricular activities on graphic design and video editing. I have also completed an intensive summer design bootcamp with Ace Design Co. I would like to use my skills with Carlton Design Firm, in order to make optimal use of my acquired knowledge.
    I would describe myself as someone who is eager to learn and passionate. I would like to put these characteristics to use within your organization. My experience as a graphic designer at my school newspaper has provided me with the expertise to be able to make a valuable contribution to Carlton Design Firm in the position of Design Intern.
    I would like to further explain my motivation for the position of Design Intern during a personal meeting. You can reach me either by phone at (111) 222-3333 or by email at justin.edwards@gmail.com.`,
    closing: 'Thank you for your time and consideration. I look forward to hearing from you.',
    footerLine1: 'سجل تجاري: 355012343',
    footerLine2: 'البريد الإلكتروني : info@qitaf.store / هاتف: 0144411555',
    footerLine3: 'تبوك 2705 - 47912 - وحدة رقم 2 - شارع معن بن زائدة 6694 - حي العزيزية القديمة - المملكة العربية السعودية',
    footerLine4: 'Tabuk 2705 - 47912 - Unit No. 2 - Muin Ibn Zaidah Street 6694 - Al Azizyah Al Qadimah Dist. - Kingdom of Saudi Arabia',
    headerImage: null,
    footerImage: null,
  });

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );

  const userID = useSelector((state) => state.authReducer.uid);
  const temp_id = useSelector((state) => state.authReducer.temp_id);
  const packageid = useSelector((state) => state.authReducer.packageid);
  const temp_pkgid = useSelector((state) => state.authReducer.temp_pkgid);
  const [showPremiumPopup, setShowPremiumPopup] = useState(false); // State for showing the premium popup


  const { id } = useParams();
  const coverRef = useRef();
  const [templateData, setTemplateData] = useState(null); // For storing template data from API
  const [loading, setLoading] = useState(true); // For handling loading state

  // Fetch template from API
  const fetchTemplate = async () => {
    try {
      const response = await fetch(`${api.API_URL}/aapi/templetes/${id}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch template: ${response.status}`);
      }
      const template = await response.json(); // Parse the JSON response
      setTemplateData(template); // Set the fetched template
      setLoading(false); // Stop loading
    } catch (error) {
      console.error("Error fetching template:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplate();
  }, [id]); // Fetch the template when the component mounts or id changes

  // Function to load and append scripts dynamically after rendering the template
  const loadScripts = () => {
    if (templateData && templateData.scripts) {
      const scripts = templateData.scripts;
      const scriptTags = Object.values(scripts);
  
      scriptTags.forEach((script) => {
        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.innerHTML = script;
  
        if (coverRef.current) {
          document.body.appendChild(scriptElement); // Append scripts after template is rendered
        }
      });
    }
  };

  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener('contextmenu', handleContextMenu);
  
    // Disable Save (Ctrl+S) and Print (Ctrl+P)
    const handleKeydown = (e) => {
      if ((e.ctrlKey && e.key === 'p') || (e.ctrlKey && e.key === 's')) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener('keydown', handleKeydown);
  
    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);
  
  // Ensure scripts run after the template is rendered and data is updated
  useEffect(() => {
    if (templateData && templateData.template) {
      // Render the template first, then load the scripts and update the template with form data
      setTimeout(() => {
        loadScripts();
        if (typeof window.updateTemplate === 'function') {
          window.updateTemplate(data); // Call the template update function to pass form data
        }
      }, 0);
    }
  }, [templateData, data]);

  // Handle changes from form input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle image changes
  const handleImageChange = (e, key) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setData((prevData) => ({
        ...prevData,
        [key]: reader.result,
      }));
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };
  
  const [showOneTimePlanPopup, setShowOneTimePlanPopup] = React.useState(false); // State for one-time plan popup
  const [showExpiredPackagePopUp, setShowExpiredPackagePopUp] = React.useState(false); // State for one-time plan popup


  const handleDownload = async () => {
    console.log(
      "user Id:", userID,
      "user package id", packageid,
      "template Package id:", temp_pkgid,
      "template id : ", temp_id
    );

    // Check if the user is allowed to download based on package levels
    if (temp_pkgid == 4) {
      try {
        // Make a POST request to check the subscription, passing userID via FormData
        const formData = new FormData();
        formData.append("userid", userID);
        formData.append("tempid", temp_id);

        console.log("FormData:", formData);
        const subscriptionResponse = await fetch(`${api.API_URL}/aapi/getusertemp_subs.php`, {
          method: 'POST',
          body: formData,
        });

        if (!subscriptionResponse.ok) {
          throw new Error("Failed to fetch subscription details");
        }

        const result = await subscriptionResponse.json();

        if (result.status === false) {
          setShowOneTimePlanPopup(true); // Show one-time plan popup if user hasn't subscribed
          return;
        }

      } catch (error) {
        console.error("Error fetching subscription or template details:", error);
        return; // Stop execution if any API call fails
      }
    } else {
      if (
        (packageid == 1 && temp_pkgid > 1) ||
        (packageid == 2 && temp_pkgid > 2) ||
        (packageid == 3 && temp_pkgid > 3)
      ) {
        setShowPremiumPopup(true);
        return; // Stop further execution
      }
      else{
        if(packageid == 6 && temp_pkgid > 1 || packageid == 7 && temp_pkgid > 1){
          setShowExpiredPackagePopUp(true);
          return;
        }
      }
    }


    const element = coverRef.current;
    const options = {
      filename: `${data.name}_coverletter.pdf`,
      image: { type: 'png', quality: 1 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'in', format: 'A4', orientation: 'portrait' },
    };
    html2pdf().from(element).set(options).save();
  };

  const handlePrint = async () => {
    console.log(
      "user Id:", userID,
      "user package id", packageid,
      "template Package id:", temp_pkgid,
      "template id : ", temp_id
    );

    // Check if the user is allowed to download based on package levels
    if (temp_pkgid == 4) {
      try {
        // Make a POST request to check the subscription, passing userID via FormData
        const formData = new FormData();
        formData.append("userid", userID);
        formData.append("tempid", temp_id);

        console.log("FormData:", formData);
        const subscriptionResponse = await fetch(`${api.API_URL}/aapi/getusertemp_subs.php`, {
          method: 'POST',
          body: formData,
        });

        if (!subscriptionResponse.ok) {
          throw new Error("Failed to fetch subscription details");
        }

        const result = await subscriptionResponse.json();

        if (result.status === false) {
          setShowOneTimePlanPopup(true); // Show one-time plan popup if user hasn't subscribed
          return;
        }
        else{
          if(packageid == 6 && temp_pkgid > 1 || packageid == 7 && temp_pkgid > 1){
            setShowExpiredPackagePopUp(true);
            return;
          }
        }

      } catch (error) {
        console.error("Error fetching subscription or template details:", error);
        return; // Stop execution if any API call fails
      }
    } else {
      if (
        (packageid == 1 && temp_pkgid > 1) ||
        (packageid == 2 && temp_pkgid > 2) ||
        (packageid == 3 && temp_pkgid > 3)
      ) {
        setShowPremiumPopup(true);
        return; // Stop further execution
      }
    }

    // Proceed with printing if package is allowed
    const printContent = useReactToPrint({
      content: () => coverRef.current,
    });
    printContent();
  };
  

  // Loading state while fetching template
  if (loading) {
    return <div>Loading...</div>;
  }

  const handlePayNow = async () => {
    const handleOpen = () => dispatch(loginModal(true));
    if (!isAuthenticated) {
      handleOpen();
      return;
    }
  
    const formData = new FormData();
    formData.append('tempid', temp_id);
  
    const apiUrl = `${api.API_URL}/aapi/gettemp_price.php`;
  
    try {
      // Make the POST request
      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
      });
  
      // Ensure the response is OK
      if (!response.ok) {
        throw new Error('Failed to fetch template price');
      }
  
      // Parse the JSON response
      const data = await response.json();
  
      // Check if the response status is success and the amount exists
      if (data.status === "success" && data.temp_amount !== undefined) {
        const amount = data.temp_amount;
        console.log("Template Amount is: ", amount);
  
        // Construct the payment URL
        const url = `${api.API_URL}/onetimepay/request.php?amount=${encodeURIComponent(amount)}&customerEmail=${encodeURIComponent(email)}&userid=${encodeURIComponent(userID)}&tempid=${encodeURIComponent(packageid)}`;
  
        // Open the payment URL in a new tab
        window.open(url, '_blank');
      } else {
        console.error('Failed to retrieve template amount or invalid response:', data);
      }
    } catch (error) {
      console.error('Error processing payment:', error);
    }
  };

  return (
    <div>
      <Navbar
        handleDownload={handleDownload}
        handlePrint={handlePrint}
        saveToLocalStorage={() => localStorage.setItem('coverLetterData', JSON.stringify(data))}
      />
      <div className="p-4">
        <div className="grid md:grid-cols-2 grid-cols-1 md:gap-0 gap-4 w-full h-full space-x-8">
          <div className="w-full">
            <FormSection
              data={data}
              handleChange={handleChange}
              handleImageChange={handleImageChange}
            />
          </div>
          <div className="w-full" ref={coverRef}>
            {/* Render the template with a placeholder for editable content */}
            <div contentEditable='false' dangerouslySetInnerHTML={{ __html: templateData.template }}></div>
          </div>
        </div>
      </div>
          
<Dialog
  icon="warning-sign"
  onClose={() => setShowPremiumPopup(false)}
  title="Premium Template"
  isOpen={showPremiumPopup}
  style={{ width: '400px', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }} // Adds custom styling
>
  <div className={Classes.DIALOG_BODY} style={{ textAlign: 'center', paddingBottom: '20px' }}>
    <p style={{ fontSize: '16px', color: '#5c7080', marginBottom: '20px' }}>
      This is a premium template. Please upgrade your package to download or print it.
    </p>
    <FaCrown size={80} color="#FFD700" style={{ margin: '0 auto', display: 'block', marginBottom: '20px' }} />
  </div>
  <div className={Classes.DIALOG_FOOTER} style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
    <Button
      intent="primary"
      style={{
        backgroundColor: '#9333EA',
        color: 'white',
        fontWeight: 'bold',
        padding: '10px 20px',
        borderRadius: '5px',
      }}
      onClick={() => navigate('/price')}
    >
      Go to Pricing Page
    </Button>
    <Button
      style={{
        backgroundColor: '#F55656',
        color: 'white',
        fontWeight: 'bold',
        padding: '10px 20px',
        borderRadius: '5px',
      }}
      onClick={() => setShowPremiumPopup(false)}
    >
      Close
    </Button>
  </div>
</Dialog>
<Dialog
        icon="warning-sign"
        onClose={() => setShowOneTimePlanPopup(false)}
        title="One-Time Plan Template"
        isOpen={showOneTimePlanPopup}
        style={{ width: '400px', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
      >
        <div className={Classes.DIALOG_BODY} style={{ textAlign: 'center', paddingBottom: '20px' }}>
          <p style={{ fontSize: '16px', color: '#5c7080', marginBottom: '20px' }}>
            This template is only available in the one-time plan. Please go and purchase it!
          </p>
          <FaCrown size={80} color="#FFD700" style={{ margin: '0 auto', display: 'block', marginBottom: '20px' }} />
        </div>
        <div className={Classes.DIALOG_FOOTER} style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <Button
            intent="primary"
            style={{
              backgroundColor: '#9333EA',
              color: 'white',
              fontWeight: 'bold',
              padding: '10px 20px',
              borderRadius: '5px',
            }}
            onClick={handlePayNow}
          >
            Buy Now
          </Button>
          <Button
            style={{
              backgroundColor: '#F55656',
              color: 'white',
              fontWeight: 'bold',
              padding: '10px 20px',
              borderRadius: '5px',
            }}
            onClick={() => setShowOneTimePlanPopup(false)}
          >
            Close
          </Button>
        </div>
      </Dialog>
      <Dialog
        icon="warning-sign"
        onClose={() => setShowExpiredPackagePopUp(false)}
        title="Package has been Expired"
        isOpen={showExpiredPackagePopUp}
        style={{ width: '400px', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
      >
        <div className={Classes.DIALOG_BODY} style={{ textAlign: 'center', paddingBottom: '20px' }}>
          <p style={{ fontSize: '16px', color: '#5c7080', marginBottom: '20px' }}>
           Your Package has been Expired. Please go and Renew it!
          </p>
          <FaExclamationTriangle  size={80} color="#FFD700" style={{ margin: '0 auto', display: 'block', marginBottom: '20px' }} />
        </div>
        <div className={Classes.DIALOG_FOOTER} style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <Button
            intent="primary"
            style={{
              backgroundColor: '#9333EA',
              color: 'white',
              fontWeight: 'bold',
              padding: '10px 20px',
              borderRadius: '5px',
            }}
            onClick={() => navigate('/price')}
          >
            Renew
          </Button>
          <Button
            style={{
              backgroundColor: '#F55656',
              color: 'white',
              fontWeight: 'bold',
              padding: '10px 20px',
              borderRadius: '5px',
            }}
            onClick={() => setShowExpiredPackagePopUp(false)}
          >
            Close
          </Button>
        </div>
      </Dialog>
    </div>
    
  );
}
